import { getFeature } from 'Cloud/Application/FeaturesEs6';

import { blackFriday2024 } from './featuresHelpers/features/blackFriday2024';

/** Настройки для показа акций типа летней, осенней, черной пятницы и т.д. */
export const ACTION_SETTINGS = {
    hide1TbTrialPromo: blackFriday2024,
    hideBannerPromo: blackFriday2024,
} as const;
export const actionTermsLink = getFeature('action-terms-link');

export const OLD_ACTION_TERMS_LINK = 'https://promoimages.hb.ru-msk.vkcs.cloud/mailspace_sale.pdf';

const actionRegexpString = getFeature('action-regexp') || '.*_blackfriday_2023_discount_single_quota_cloud$';

export const actionRegExp = new RegExp(actionRegexpString);

export const ACTION_NAME_ANALYTICS = getFeature('action-name-analytics');
